enum FilterCodeEnum {
  Category = 'category',
}

export default FilterCodeEnum;
